/* eslint-disable */
export const selectCompany = state => state.company;
